import * as React from 'react'
import Link from 'next/link'
import styled from 'styled-components'
import { useFeature, useFlag } from 'toggled'

import { analytics } from '~/analytics'
import Alert from '~/truck/alert'
import Anchor from '~/truck/anchor'
import Button from '~/truck/button'
import Field from '~/truck/field'
import Icon from '~/truck/icon'
import Label from '~/truck/label'
import { flags } from '~/utils/constants'

import SocialLoginButtons from '../social-login-buttons'

import { Form, FormContainer } from './elements'

const StyledIcon = styled(Icon)`
  vertical-align: middle;
`

const LoginForm = props => {
  const { handleSubmit, submitting, style, className, submitErrors } = props

  const hasPartnersFF = useFlag(flags.MULTI_VENDOR_NAVIGATION)

  const hasEnableCodeToLoginFF = useFlag(flags.ENABLE_CODE_TO_LOGIN)

  const preSignUpFeature = useFeature(flags.PRE_SIGN_UP)

  const preSignUpURL = preSignUpFeature?.settings?.url

  const encodedURL = '/redirect?callback=' + encodeURIComponent(preSignUpURL)

  const redirectAnalytics = () => analytics.preSignUpAttempt()

  const generalError = submitErrors?.credentials || submitErrors?.rateLimit

  return (
    <FormContainer>
      {generalError && <Alert type="error" message={generalError} />}
      <Form onSubmit={handleSubmit} style={style} className={className}>
        {hasEnableCodeToLoginFF ? (
          <Field name="code" placeholder="Código" />
        ) : (
          <Field name="email" placeholder="Correo" />
        )}
        <Field name="password" placeholder="Contraseña" type="password" />
        <Button loading={submitting}>Ingresar</Button>
        <SocialLoginButtons />
        {!hasPartnersFF && (
          <Link passHref href="/recuperar-contrasena">
            <Anchor $color="info" $textStyle="h6Regular">
              ¿Olvidaste tu contraseña?
            </Anchor>
          </Link>
        )}
        {preSignUpURL && (
          <Label as="p" $textStyle="h6Regular">
            ¿No cuentas con acceso a la tienda?&nbsp;
            <Anchor target="_blank" href={encodedURL} $color="info" onClick={redirectAnalytics} $textStyle="h6Regular">
              Solicítalo aquí&nbsp;
              <StyledIcon color="info" type="launch" size="sm"></StyledIcon>
            </Anchor>
          </Label>
        )}
      </Form>
    </FormContainer>
  )
}

export default LoginForm
